export const jenisSurat = [
  { id: 1, code: 'Umum', name: 'Surat Perihal Umum', is_event: 0 },
  { id: 2, code: 'Keuangan', name: 'Surat Perihal Keuangan', is_event: 0 },
  { id: 3, code: 'Proposal', name: 'Surat Perihal Proposal', is_event: 0 },
  { id: 4, code: 'Radiogram', name: 'Surat Perihal Radiogram', is_event: 0 },
  { id: 5, code: 'Audiensi', name: 'Surat Perihal Audiensi', is_event: 1 },
  { id: 6, code: 'Undangan', name: 'Surat Perihal Undangan', is_event: 1 }
]
